import Item from "./components/Item";
import SecondItem from "./components/SecondItem";
import { Section } from "./styles/index.styled";

function Features() {
  return (
    <Section>
      <Item />
      <SecondItem />
    </Section>
  );
}

export default Features;
